export { default as OtcProductContainer } from './product';
export { default as OtcMedicineContainer } from './otc-medicine';
export { default as OtcPlpContainer } from './products-list';
